import { LogoutOutlined } from '@ant-design/icons';
import { Button } from 'antd';
import jwtDecode from 'jwt-decode';
import React from 'react';
import { styled } from 'styled-components';

export default function UserInfo() {
  const token = localStorage.getItem('token');
  if (!token) 
    return <></>;

  const user: any = jwtDecode(token!);
  const logout = () => {
    localStorage.removeItem('token');
    window.location.reload();
  };

  return (
    <>
      <Profile src={user.profile} alt='user profile' />
      <br />
      <Info>
        Hi {user.name} {user.family}! &nbsp;
        <Button
          shape='circle'
          onClick={logout}
          type="primary"
          icon={<LogoutOutlined />}
          size='middle'
          danger
        ></Button>
      </Info>
    </>
  );
}

const Info = styled.div`
  font-size: 16px;
  color: #ffffff;
  margin-left: 10px;
`;

const Profile = styled.img`
  width: 50px;
  height: 50px;
  border-radius: 50%;
  margin-left: 10px;
`;
